import Toast from './toast';

export default class ShoelaceFormValidator {
    /**
     * @var {SlSelect[]}
     */
    _selects;

    /**
     * @var {SlInput[]}
     */
    _inputs;

    /**
     * @var {SlCheckbox[]}
     */
    _checkboxes;

    /**
     * @var {SlForm}
     */
    _form;

    /**
     * @var {string}
     */
    _localeShort;

    /**
     * @var {string}
     */
    _emailValidationURL;

    // @ts-ignore
    constructor(form, localeShort, emailvalidationUrl) {
        this._form = form;
        this._localeShort = localeShort;
        this._emailValidationURL = emailvalidationUrl;

        this._selects = Array.from(form.querySelectorAll('sl-select'));
        this._inputs = Array.from(form.querySelectorAll('sl-input'));
        this._checkboxes = Array.from(form.querySelectorAll('sl-checkbox'));
    }

    // @ts-ignore
    setElementValid(el) {
        el.classList.remove('invalid');
        el.classList.add('valid');
        el.removeAttribute('form-control-help-text');
        if (el.nodeName === 'SL-SELECT') {
            this.markSlSelectAsValid(el, false);
        } else if (el.nodeName === 'SL-CHECKBOX') {
            this.markSlCheckboxAsValid(el);
        } else {
            this.markSlInputAsValid(el);
        }
    }

    // @ts-ignore
    markSlSelectAsInvalid(slSelect) {
        slSelect.shadowRoot.querySelector('.select__combobox').style.borderColor = 'var(--color-form-invalid)';
    }

    // @ts-ignore
    markSlSelectAsValid(slSelect, active) {
        let select = slSelect.shadowRoot.querySelector('.select__combobox');

        if (true === active) {
            select.style.borderColor = 'var(--sl-input-border-color-focus)';
        } else {
            select.style.borderColor = 'var(--sl-input-border-color)';
        }
    }

    // @ts-ignore
    markSlCheckboxAsValid(slCheckbox) {
        slCheckbox.classList.remove('invalid');
    }

    // @ts-ignore
    markSlInputAsValid(slInput) {
        slInput.shadowRoot.querySelector('.input__suffix').innerHTML = '<sl-icon name="check-lg" slot="suffix" style="margin: 5px;"></sl-icon>';
    }

    // @ts-ignore
    markSlInputAsInvalid(slInput) {
        slInput.shadowRoot.querySelector('.input__suffix').innerHTML = '<sl-icon name="x-lg" slot="suffix" style="margin: 5px;"></sl-icon>';
    }

    // @ts-ignore
    removeSlInputValidationMark(slInput) {
        slInput.shadowRoot.querySelector('.input__suffix').innerHTML = '';
    }

    // @ts-ignore
    markSlCheckboxAsInvalid(slCheckbox) {
        slCheckbox.classList.add('invalid');
    }

    // @ts-ignore
    setElementInvalid(el) {
        el.classList.remove('valid');
        el.classList.add('invalid');
        if (el.nodeName === 'SL-SELECT') {
            this.markSlSelectAsInvalid(el);
        } else if (el.nodeName === 'SL-CHECKBOX') {
            this.markSlCheckboxAsInvalid(el);
        } else {
            this.markSlInputAsInvalid(el);
        }
    }

    // @ts-ignore
    checkServerValidation(response) {
        return response.success;
    }

    // @ts-ignore
    processServerValidationResponse(response) {
        if (response.success) {
            for (const select of this._selects) {
                this.setElementValid(select);
            }
            for (const input of this._inputs) {
                this.setElementValid(input);
            }
            for (const checkbox of this._checkboxes) {
                this.setElementValid(checkbox);
            }
            return;
        }

        const errors = this.mapServerValidationErrorsToFormFields(response.validation_errors);

        // @ts-ignore
        const markAsInvalid = (element) => {
            // @ts-ignore
            if (!errors[element.name]) {
                return;
            }
            this.setElementInvalid(element);
            // select.setCustomValidity(errors[select.name]);
            // @ts-ignore
            element.setAttribute('form-control-help-text', errors[element.name]);
            // element.reportValidity();
        };

        for (const select of this._selects) {
            markAsInvalid(select);
        }
        for (const input of this._inputs) {
            markAsInvalid(input);
        }
        for (const checkbox of this._checkboxes) {
            markAsInvalid(checkbox);
        }
    }

    // @ts-ignore
    mapServerValidationErrorsToFormFields(serverValidationErrors) {
        const errors = {};
        for (const [group, groupFields] of Object.entries(serverValidationErrors)) {
            if (typeof groupFields === 'string') {
                // @ts-ignore
                errors[group] = groupFields;
                continue;
            }
            // @ts-ignore
            for (const [name, errorMsg] of Object.entries(groupFields)) {
                const fieldName = `${group}[${name}]`;
                // @ts-ignore
                errors[fieldName] = errorMsg;
            }
        }
        return errors;
    }

    // @ts-ignore
    async validateEmail(el) {
        if (!el.classList.contains('no_remote_validation')) {
            await this.checkIfEmailAlreadyExists(el);
        } else {
            const re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (String(el.value).length === 0 || re.test(String(el.value).toLowerCase())) {
                this.setElementValid(el);
            } else {
                this.setElementInvalid(el);
            }
        }
    }

    // @ts-ignore
    async checkIfEmailAlreadyExists(el) {
        const emailValidationURL = `${this._emailValidationURL}${el.value}`;
        const settings = {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
        };

        try {
            // @ts-ignore
            const request = await fetch(emailValidationURL, settings);
            const response = await request.json();

            const t = new Toast('email-hint');
            await t.removeAllToasts();

            const hintElement = document.getElementById('duplicate-email-hint');
            const submitAddressButton = document.querySelector('#btn_step_1');
            // mailexists is true if we already know this mail address
            if (response.mailexists) {
                this.setElementInvalid(el);
                if (hintElement) {
                    hintElement.style.display = 'flex';
                } else {
                    t.createToast(
                        'danger',
                        `
                        <sl-icon slot="icon" name="exclamation-octagon"></sl-icon>
                        ${response.message}
                    `,
                    );
                }
                if (submitAddressButton) {
                    // @ts-ignore
                    submitAddressButton.disabled = true;
                }
            } else {
                this.setElementValid(el);
                if (hintElement) {
                    // @ts-ignore
                    hintElement.style.display = 'none';
                }
                if (submitAddressButton) {
                    // @ts-ignore
                    submitAddressButton.disabled = false;
                }
            }
        } catch (error) {
            console.error('Error:', error);
            // Fehlermeldung???
        }
    }

    attachListener() {
        [].forEach.call(this._inputs, (el) => {
            // @ts-ignore
            el.addEventListener('sl-focus', () => {
                // @ts-ignore
                el.classList.remove('valid', 'invalid');
                this.removeSlInputValidationMark(el);
            });

            // @ts-ignore
            el.addEventListener('sl-blur', (event) => {
                if (event.target.checkValidity()) {
                    if (event.target.type === 'email') {
                        this.validateEmail(event.target);
                    } else {
                        this.setElementValid(event.target);
                    }
                } else {
                    this.setElementInvalid(event.target);
                }
            });
        });

        [].forEach.call(this._selects, (el) => {
            // @ts-ignore
            el.addEventListener('sl-focus', () => {
                // @ts-ignore
                el.classList.remove('valid', 'invalid');
                this.markSlSelectAsValid(el, true);
            });

            // @ts-ignore
            el.addEventListener('sl-blur', () => {
                this.markSlSelectAsValid(el, false);
            });

            // @ts-ignore
            el.addEventListener('sl-change', (event) => {
                if (event.target.checkValidity()) {
                    this.setElementValid(event.target);
                } else {
                    this.setElementInvalid(event.target);
                }
            });
        });

        [].forEach.call(this._checkboxes, (el) => {
            // @ts-ignore
            el.addEventListener('sl-change', (event) => {
                if (event.target.checkValidity()) {
                    this.setElementValid(event.target);
                } else {
                    this.setElementInvalid(event.target);
                }
            });
        });
    }
}
